"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createCustomError = createCustomError;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _constants = require("./constants");
var _internals = require("./internals");
/**
 * Function for creating custom error classes. Such custom error class properly subclasses built-in `Error` and simplifies
 * generating error messages via predefined error codes.
 *
 * @param errorName Error name.
 * @param errorMessages Object containing all possible error messages.
 * @return Class that implements {@linkcode CustomError}.
 */
function createCustomError(errorName, errorMessages) {
  return class InternalCustomError extends Error {
    constructor(errorCode, options) {
      const errorMessage = (0, _internals.createErrorMessage)(errorCode, errorMessages, options?.messageParameters);
      const errorOptions = {};
      if (typeof options?.cause !== 'undefined') {
        errorOptions.cause = options.cause;
      }
      super(errorMessage, errorOptions);
      (0, _defineProperty2.default)(this, "code", void 0);
      this.code = errorCode;
      this.name = errorName;

      // if the message is empty, we are making this an unknown error
      if (!this.message) {
        this.code = _constants.UNKNOWN_ERROR;
        this.message = (0, _internals.createErrorMessage)(_constants.UNKNOWN_ERROR, _constants.INTERNAL_ERROR_MESSAGES);
      }
    }
  };
}
